// PT-friendly errors for Evaluator / E5 / outcomes (never show raw "Not Found").

export function formatSelfImproveError(message, { status } = {}) {
  const m = String(message || '').trim();
  const lower = m.toLowerCase();

  if (!m) return '';

  if (
    status === 404 ||
    lower === 'not found' ||
    /path_not_found/i.test(m) ||
    /no pending outcome/i.test(m)
  ) {
    if (/no pending outcome/i.test(m)) {
      return 'Nenhuma execução registrada no servidor para esta sessão. Rode o agente no chat (o ledger registra ao fim de cada run) ou clique "Registrar execução" abaixo.';
    }
    if (/summary|aggregate|evaluator|outcomes\/summary/i.test(m)) {
      return 'API desatualizada — rotas do ledger não existem no servidor. No Mac: cd ~/Apolo/apolo-api && npx wrangler deploy';
    }
    return 'Nenhuma execução registrada no servidor para esta sessão. Rode o agente no chat (o ledger registra ao fim de cada run) ou clique "Registrar execução" abaixo.';
  }

  if (/session not found/i.test(m)) {
    return 'Sessão não encontrada no servidor — recarregue a lista de sessões.';
  }

  if (/evaluator is rate-limited|rate_limited/i.test(m)) {
    return 'Avaliador em cooldown — aguarde ~30s e tente novamente.';
  }

  if (/evaluator run failed|failed to aggregate/i.test(m)) {
    return 'Falha ao rodar o avaliador no servidor. Verifique se a migration agent_outcomes (0053) foi aplicada no D1 e se apolo-api está deployada.';
  }

  if (/failed to record outcome|failed to aggregate|agent_outcomes|no such table/i.test(m)) {
    return `Ledger indisponível no servidor (${m}). No Mac:\ncd ~/Apolo/apolo-api\nnpx wrangler d1 execute apolo-ide-db --remote --file=migrations/0053_agent_outcomes.sql\nnpx wrangler d1 execute apolo-ide-db --remote --file=migrations/0055_agent_outcomes_repo_slug.sql\nnpx wrangler deploy`;
  }

  if (/git bridge unavailable/i.test(m)) {
    return 'Bridge git indisponível — use o app Electron, não o browser.';
  }

  if (/outcome not found/i.test(m)) {
    return 'Outcome não encontrado — rode o agente nesta sessão antes de sincronizar o sinal git (E5).';
  }

  if (status === 401 || /unauthorized|token expired|token invalid|token revoked/i.test(m)) {
    return 'Sessão expirada — faça login de novo.';
  }

  if (status === 0 || /network error|failed to fetch/i.test(m)) {
    return 'Sem conexão com a API. Verifique internet ou se apolo-api está no ar.';
  }

  return m;
}

/** @deprecated use formatSelfImproveError */
export function formatE5Error(message) {
  return formatSelfImproveError(message);
}

export function isSelfImproveInfoMessage(text) {
  const t = String(text || '');
  return (
    /Avaliador rodou/i.test(t) ||
    /Ainda não há execuções/i.test(t) ||
    /Sinal externo aplicado/i.test(t) ||
    /Nenhuma execução do agente/i.test(t)
  );
}

/** True when the raw API error should render as info, not a hard failure. */
export function isSelfImproveSoftError(message) {
  const m = String(message || '').trim().toLowerCase();
  return m === 'not found' || /no pending outcome/i.test(m);
}
